import React from 'react';
interface WavyDividerProps {
  className?: string;
  fill?: string;
  position?: 'top' | 'bottom';
}
export function WavyDivider({
  className = '',
  fill = '#F8F2E4',
  position = 'bottom'
}: WavyDividerProps) {
  // For "bottom" placement (default): the wave sits below a section and
  // points DOWN, with the solid fill anchored to the bottom edge.
  // For "top" placement: flip vertically so the fill anchors to the top edge.
  const transform = position === 'top' ? 'scaleY(-1)' : 'none';
  return <div aria-hidden="true" className={`pointer-events-none block w-full overflow-hidden leading-none ${className}`} style={{
    transform,
    marginTop: '-1px',
    marginBottom: '-1px'
  }} data-id="element-398" data-mp="1n3om4t6zoz4k">
      <svg className="relative block w-full h-[100px] md:h-[150px] lg:h-[200px]" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1200 120" preserveAspectRatio="none" data-id="element-399" data-mp="1w29yu7ps5jxf">
        {/* Back layer — single broad sine cycle, lightest */}
        <path d="M 0,85 C 200,30 400,30 600,85 C 800,135 1000,135 1200,85 L 1200,120 L 0,120 Z" opacity="0.3" fill={fill} data-id="element-400" data-mp="7ajonjrg0q21" />
        {/* Mid layer — phase-shifted, 1.5 cycles */}
        <path d="M 0,75 C 150,15 300,15 450,75 C 600,130 750,130 900,70 C 1050,20 1150,30 1200,55 L 1200,120 L 0,120 Z" opacity="0.55" fill={fill} data-id="element-401" data-mp="haaj5lg07524" />
        {/* Foreground — opposite-phase sweeping wave */}
        <path d="M 0,90 C 200,130 400,130 600,75 C 800,30 1000,30 1200,80 L 1200,120 L 0,120 Z" fill={fill} data-id="element-402" data-mp="3ppkjao0c2079" />
      </svg>
    </div>;
}